// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"5ebb884cbd57ab71","7853":"53e2a3b31477ca62","8960":"29046ad685444e73"}[chunkId] + ".css";
};